import { render, staticRenderFns } from "./historicalRecords.vue?vue&type=template&id=61fff4da&scoped=true&xmlns=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml"
import script from "./historicalRecords.vue?vue&type=script&lang=js"
export * from "./historicalRecords.vue?vue&type=script&lang=js"
import style0 from "./historicalRecords.vue?vue&type=style&index=0&id=61fff4da&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61fff4da",
  null
  
)

export default component.exports